import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface AppBarProps {
  /** show the TEBIKI wordmark + glyph (default true) */
  brand?: boolean;
  /** smaller field-style brand */
  compactBrand?: boolean;
  /** a back link rendered as a large (>=56px) ghost button — field surfaces */
  back?: string;
  backLabel?: ReactNode;
  /** content shown in the middle (e.g. kicker + stepper) */
  center?: ReactNode;
  /** right-aligned controls */
  children?: ReactNode;
  className?: string;
}

/** Sticky top bar used by both field and console shells. */
export function AppBar({
  brand = true,
  compactBrand,
  back,
  backLabel = "‹",
  center,
  children,
  className,
}: AppBarProps) {
  return (
    <header className={["appbar", className].filter(Boolean).join(" ")}>
      {back ? (
        <Link
          className="btn btn--ghost"
          to={back}
          aria-label="戻る"
          style={{ minHeight: 56, minWidth: 56, padding: "8px 14px", borderRadius: 12 }}
        >
          {backLabel}
        </Link>
      ) : null}
      {brand ? (
        <Link className="brand" to="/" style={{ fontSize: compactBrand ? 17 : undefined }}>
          <span className="glyph" aria-hidden="true" />
          TEBIKI
        </Link>
      ) : null}
      {center ? <div className="grow">{center}</div> : <span className="grow" />}
      {children}
    </header>
  );
}
